import { render, staticRenderFns } from "./DefaultTabs.vue?vue&type=template&id=4c2097d6&scoped=true&"
import script from "./DefaultTabs.vue?vue&type=script&lang=js&"
export * from "./DefaultTabs.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTabs.vue?vue&type=style&index=0&id=4c2097d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2097d6",
  null
  
)

export default component.exports